import React, { useEffect, useRef, useState } from "react";
import arial from "../../noto.ttf";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { skipLineText } from "../../hooks/SplitText";
import CopiarURL from "../../hooks/CopiarUrl";

const RenderVideoTwo = ({
  imgOneVideoTwo,
  imgTwoVideoTwo,
  imgThreeVideoTwo,
  imgFourVideoTwo,
  imgFiveVideoTwo,
  textOneVideoTwo,
  textThreeVideoTwo,
  textFiveVideoTwo,
  songSelected,
  textColorOne,
  textColorTwo,
  textColorThree,
  setIsUpdateGalery,
}) => {
  const [videoSrc, setVideoSrc] = useState("");
  const [isLoader, setIsLoader] = useState(true);
  const [urlVideo, setUrlVideo] = useState();
  const [count, setCount] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);

  const [isError, setIsError] = useState(false);

  const [thumbail, setThumbail] = useState(true);

  const ffmpeg = createFFmpeg({
    // corePath: "http://localhost:3000/ffmpeg-core.js",
    corePath: "https://cantirondas.com/videopersonalizado/ffmpeg-core.js",
    // wasmMemory: 256 * 1024 * 1024,
    // log: true,
  });

  useEffect(() => {
    doTranscode();

    const timeLimit = 1 * 60 * 1000;
    setTimeout(() => {
      if (count === 0) {
        setIsError(true);
      }
    }, timeLimit);
  }, []);

  const handleCount = (num, init) => {
    let i = init;
    intervalRef.current = setInterval(() => {
      setCount(i);
      if (i < num) {
        i++;
      }
      if (i > num) {
        clearInterval(intervalRef.current);
      }
    }, 500);
  };

  const clearCount = () => {
    clearInterval(intervalRef.current);
  };

  const doTranscode = async () => {
    try {
      await Promise.all([
        ffmpeg.load(),
        fetchFile(imgOneVideoTwo),
        fetchFile(arial),
        fetchFile(imgTwoVideoTwo),
        fetchFile(imgThreeVideoTwo),
        fetchFile(imgFourVideoTwo),
        fetchFile(imgFiveVideoTwo),
        fetchFile(songSelected),
      ]);

      const inputPaths = [];

      ffmpeg.FS("writeFile", "image.png", await fetchFile(imgOneVideoTwo));
      ffmpeg.FS("writeFile", "arial.ttf", await fetchFile(arial));

      setIsLoader(true);
      handleCount(10, 0);
      await ffmpeg.run(
        "-loop",
        "1",
        "-framerate",
        "1",
        "-t",
        "5",
        "-i",
        "image.png",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-vf",
        "scale='min(480,iw)':min'(854,ih)':force_original_aspect_ratio=decrease,pad=480:854:(ow-iw)/2:(oh-ih)/2",
        "-video_track_timescale",
        "30k",
        "img_1.mp4"
      );
      clearCount();
      handleCount(20, 10);

      const [textOneLineOne, textOnelineTwo] = skipLineText(textOneVideoTwo);

      await ffmpeg.run(
        "-i",
        "img_1.mp4",
        "-max_muxing_queue_size",
        "1024",
        "-vf",
        `drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textOneLineOne}':fontcolor=${textColorOne}:fontsize=33:x=(w-text_w)/2:y=h-text_h-200,drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textOnelineTwo}':fontcolor=${textColorOne}:fontsize=33:x=(w-text_w)/2:y=h-text_h-150`,
        "output_img_1.mp4"
      );

      await inputPaths.push("file output_img_1.mp4");

      ffmpeg.FS("writeFile", "image_two.png", await fetchFile(imgTwoVideoTwo));
      clearCount();
      handleCount(30, 20);
      await ffmpeg.run(
        "-loop",
        "1",
        "-framerate",
        "1",
        "-t",
        "5",
        "-i",
        "image_two.png",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-vf",
        "scale='min(480,iw)':min'(854,ih)':force_original_aspect_ratio=decrease,pad=480:854:(ow-iw)/2:(oh-ih)/2",
        "-video_track_timescale",
        "30k",
        "img_2.mp4"
      );
      clearCount();
      handleCount(40, 30);

      await ffmpeg.run(
        "-i",
        "img_2.mp4",
        "-max_muxing_queue_size",
        "1024",
        "-vf",
        `drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='':fontcolor=white:fontsize=33:x=(w-text_w)/2:y=h-text_h-200`,
        "output_img_2.mp4"
      );

      await inputPaths.push("file output_img_2.mp4");

      ffmpeg.FS("writeFile", "image_three.png", await fetchFile(imgThreeVideoTwo));
      clearCount();
      handleCount(50, 40);
      await ffmpeg.run(
        "-loop",
        "1",
        "-framerate",
        "1",
        "-t",
        "5",
        "-i",
        "image_three.png",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-vf",
        "scale='min(480,iw)':min'(854,ih)':force_original_aspect_ratio=decrease,pad=480:854:(ow-iw)/2:(oh-ih)/2",
        "-video_track_timescale",
        "30k",
        "img_3.mp4"
      );
      clearCount();
      handleCount(60, 50);

      const [textTwoLineOne, textTwolineTwo] = skipLineText(textThreeVideoTwo);

      await ffmpeg.run(
        "-i",
        "img_3.mp4",
        "-max_muxing_queue_size",
        "1024",
        "-vf",
        `drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textTwoLineOne}':fontcolor=${textColorTwo}:fontsize=33:x=(w-text_w)/2:y=h-text_h-200,drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textTwolineTwo}':fontcolor=${textColorTwo}:fontsize=33:x=(w-text_w)/2:y=h-text_h-150`,
        "img_3_output.mp4"
      );

      await inputPaths.push("file img_3_output.mp4");

      ffmpeg.FS("writeFile", "image_four.png", await fetchFile(imgFourVideoTwo));
      clearCount();
      handleCount(70, 60);
      await ffmpeg.run(
        "-loop",
        "1",
        "-framerate",
        "1",
        "-t",
        "5",
        "-i",
        "image_four.png",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-vf",
        "scale='min(480,iw)':min'(854,ih)':force_original_aspect_ratio=decrease,pad=480:854:(ow-iw)/2:(oh-ih)/2",
        "-video_track_timescale",
        "30k",
        "img_4.mp4"
      );
      clearCount();
      handleCount(80, 70);

      await ffmpeg.run(
        "-i",
        "img_4.mp4",
        "-max_muxing_queue_size",
        "1024",
        "-vf",
        `drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='':fontcolor=white:fontsize=33:x=(w-text_w)/2:y=h-text_h-200`,
        "output_img_4.mp4"
      );

      await inputPaths.push("file output_img_4.mp4");

      ffmpeg.FS("writeFile", "image_five.png", await fetchFile(imgFiveVideoTwo));

      clearCount();
      handleCount(90, 80);

      await ffmpeg.run(
        "-loop",
        "1",
        "-framerate",
        "1",
        "-t",
        "5",
        "-i",
        "image_five.png",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-vf",
        "scale='min(480,iw)':min'(854,ih)':force_original_aspect_ratio=decrease,pad=480:854:(ow-iw)/2:(oh-ih)/2",
        "-video_track_timescale",
        "30k",
        "img_5.mp4"
      );

      const [textThreeLineOne, textThreelineTwo] = skipLineText(textFiveVideoTwo);

      await ffmpeg.run(
        "-i",
        "img_5.mp4",
        "-max_muxing_queue_size",
        "1024",
        "-vf",
        `drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textThreeLineOne}':fontcolor=${textColorThree}:fontsize=33:x=(w-text_w)/2:y=h-text_h-200,drawtext=enable='between(t,0,05)':fontfile=arial.ttf:text='${textThreelineTwo}':fontcolor=${textColorThree}:fontsize=33:x=(w-text_w)/2:y=h-text_h-150`,
        "output_img_5.mp4"
      );
      await inputPaths.push("file output_img_5.mp4");

      //concat---------------------------------------concat

      await ffmpeg.FS("writeFile", "concat_list.txt", inputPaths.join("\n"));

      clearCount();
      handleCount(99, 90);
      await ffmpeg.run("-f", "concat", "-safe", "0", "-i", "concat_list.txt", "-max_muxing_queue_size", "1024", "finalVideo.mp4");

      await ffmpeg.FS("writeFile", "sound.mp3", await fetchFile(songSelected));

      await ffmpeg.run(
        "-i",
        "finalVideo.mp4",
        "-i",
        "sound.mp3",
        "-c",
        "copy",
        "-map",
        "0:v:0",
        "-map",
        "1:a:0",
        "-c:a",
        "aac",
        "-t",
        "25",
        "output.mp4"
      );

      setCount(100);
      setIsLoader(false);
      const data = ffmpeg.FS("readFile", "output.mp4");

      await setVideoSrc(URL.createObjectURL(new Blob([data.buffer], { type: "video/mp4" })));

      const videoBlob = new Blob([data.buffer], { type: "video/mp4" });
      const url = URL.createObjectURL(videoBlob);
      setUrlVideo(url);
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveVideo = (url) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], "video.mp4");
        const formData = new FormData();
        formData.append("archivo", file);

        fetch("https://cloudinary-app.herokuapp.com/api/upload/", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            setIsUploading(false);
            const id = data.data.result.asset_id;
            axios.post("https://likes-count-app.herokuapp.com/likes", {
              id_video: id,
              likes: 0,
            });
            setIsUpdateGalery(true);
            navigate("/galeria");
          })
          .catch((error) => {
            console.error(error);
            setIsUploading(false);
          });
      });
  };
  return (
    <div className="render_video_one">
      {isLoader ? (
        <div className="loader anim_slider animate__animated animate__bounceInRight">
          <h1 className="containerAll text_loader_one">TU VIDEO SE ESTÁ PROCESANDO</h1>
          <h2 className="containerAll text_loader_two">Por favor no cierres la ventana de tu navegador</h2>

          <div className="spinner">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
            <div className="bar4"></div>
            <div className="bar5"></div>
            <div className="bar6"></div>
            <div className="bar7"></div>
            <div className="bar8"></div>
            <div className="bar9"></div>
            <div className="bar10"></div>
            <div className="bar11"></div>
            <div className="bar12"></div>
            <p className="porcent">{count}%</p>
          </div>

          {isError && (
            <section className="erro_chorme">
              <div className={`container_chorme_2 ${!isError && "disable_chorme"}`}>
                <img src="/assets/error_chorme/2.png" alt="" />
                <div className="info_error info_error_two">
                  <h1 className="title_error">Parece que se está demorando mucho...</h1>
                  <p className="text_error">
                    Parece que la versión de tu celular no está optimizada para este proceso. Si el contador sigue en 0%, te invitamos a continuar en
                    tu computador.
                  </p>
                  <div className="copy">
                    <CopiarURL setIsCopied={setIsCopied} variant={2} />
                    {!isCopied ? <p>Copiar link</p> : <p>Link copiado</p>}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      ) : isUploading ? (
        <div className="loader">
          <h1 className="containerAll text_loader_one">TU VIDEO SE ESTÁ SUBIENDO</h1>
          <h2 className="containerAll text_loader_two">Por favor no cierres la ventana de tu navegador</h2>
          <div className="spinner">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
            <div className="bar4"></div>
            <div className="bar5"></div>
            <div className="bar6"></div>
            <div className="bar7"></div>
            <div className="bar8"></div>
            <div className="bar9"></div>
            <div className="bar10"></div>
            <div className="bar11"></div>
            <div className="bar12"></div>
          </div>
        </div>
      ) : (
        <div className="render_video_one_container containerAll">
          <div className="destock_one">
            <h4>
              <strong>¡Listo!</strong> Ahora puedes reproducirlo, descargarlo o publicarlo en la galería pública de nuestra página web para
              compartirlo con el mundo.
            </h4>

            <div className="video_thumbail">
              <video preload="auto" className="videoInfo" muted={false} src={videoSrc} crossOrigin="anonymous" controls></video>

              <img
                onClick={() => {
                  setThumbail(false);
                  document.querySelector(".videoInfo").play();
                }}
                className={`thumbail ${!thumbail ? "thumbail_close" : ""}`}
                src="/assets/thumb.jpeg"
                alt=""
              />
            </div>
          </div>

          <div className="destock_two">
            <div className="button_one">
              <button crossOrigin="anonymous">
                <a href={videoSrc} download>
                  Descargar
                </a>
              </button>
            </div>
            <div className="button_two">
              <button
                disabled={isClicked}
                crossOrigin="anonymous"
                onClick={() => {
                  saveVideo(urlVideo);
                  setIsClicked(true);
                  setIsUploading(true);
                }}
              >
                Publicar
              </button>
            </div>

            <div className="button_galery">
              <button onClick={() => navigate("/galeria")}>Ir a la galería</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RenderVideoTwo;
